<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import { startIdleDetection, stopIdleDetection } from '@/utils/idle'
import { hasValidLoginStorage, handleIdleLogout } from '@/utils/auth'

export default {
  name: 'statistics',
  data() {
    return {
      idleEvents: [
        'mousedown', 'mousemove', 'keydown',
        'scroll', 'click', 'touchstart'
      ],
      idleListening: false
    }
  },
  computed: {
    isLoggedIn() {
      return hasValidLoginStorage()
    }
  },
  mounted() {
    this.syncIdleDetection()
    this.$watch('$route', () => {
      this.syncIdleDetection()
    })
  },
  methods: {
    syncIdleDetection() {
      if (this.isLoggedIn) {
        if (!this.idleListening) {
          this.initIdleDetection()
        } else {
          this.resetIdleTimer()
        }
      } else if (this.idleListening) {
        this.teardownIdleDetection()
      }
    },
    initIdleDetection() {
      this.idleEvents.forEach(event => {
        window.addEventListener(event, this.handleUserActivity)
      })
      this.idleListening = true
      this.resetIdleTimer()
    },
    teardownIdleDetection() {
      this.idleEvents.forEach(event => {
        window.removeEventListener(event, this.handleUserActivity)
      })
      stopIdleDetection()
      this.idleListening = false
    },
    resetIdleTimer() {
      if (!this.isLoggedIn) return
      startIdleDetection(
        () => this.handleIdleTimeout(),
        () => {}
      )
    },
    handleUserActivity() {
      this.resetIdleTimer()
    },
    handleIdleTimeout() {
      if (!this.isLoggedIn) return
      this.teardownIdleDetection()
      handleIdleLogout()
    }
  },
  beforeDestroy() {
    this.teardownIdleDetection()
  }
}
</script>
<style>
  body{
    margin: 0;
  }
  #app{
    min-width: 1300px;
  }
</style>
